var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/**
 * 错误处理器
 * 提供统一的错误处理和降级策略
 */
export class ErrorHandler {
    constructor() {
        this.errorCallbacks = [];
        this.isDebugEnabled = false;
    }
    /**
     * 获取单例实例
     */
    static getInstance() {
        if (!this.instance) {
            this.instance = new ErrorHandler();
        }
        return this.instance;
    }
    /**
     * 启用调试模式
     */
    enableDebug(enabled = true) {
        this.isDebugEnabled = enabled;
    }
    /**
     * 添加错误回调
     */
    onError(callback) {
        this.errorCallbacks.push(callback);
    }
    /**
     * 移除错误回调
     */
    offError(callback) {
        const index = this.errorCallbacks.indexOf(callback);
        if (index > -1) {
            this.errorCallbacks.splice(index, 1);
        }
    }
    /**
     * 处理API不支持的错误
     */
    handleApiNotSupported(apiName, platformType, fallback) {
        const error = {
            type: 'api_not_supported',
            message: `API '${apiName}' 不支持在 '${platformType}' 运行`,
            apiName,
            platformType,
        };
        this.emitError(error);
        if (fallback) {
            try {
                return fallback();
            }
            catch (fallbackError) {
                this.handleApiFailed(apiName, platformType, fallbackError);
                return this.getDefaultFallback(apiName);
            }
        }
        return this.getDefaultFallback(apiName);
    }
    /**
     * 处理API执行失败的错误
     */
    handleApiFailed(apiName, platformType, originalError) {
        const error = {
            type: 'api_failed',
            message: `API '${apiName}' 执行失败，'${platformType}': ${originalError.message}`,
            apiName,
            platformType,
            originalError,
        };
        this.emitError(error);
        return this.getDefaultFallback(apiName);
    }
    /**
     * 处理降级使用
     */
    handleFallbackUsed(apiName, platformType, fallbackName) {
        const error = {
            type: 'fallback_used',
            message: `使用降级 '${fallbackName}' API '${apiName}' 在 '${platformType}'`,
            apiName,
            platformType,
        };
        this.emitError(error);
    }
    /**
     * 安全执行函数
     */
    safeExecute(apiName, platformType, fn, fallback) {
        try {
            return fn();
        }
        catch (error) {
            return this.handleApiFailed(apiName, platformType, error);
        }
    }
    /**
     * 获取默认降级值
     */
    getDefaultFallback(apiName) {
        var _a;
        const defaults = {
            innerWidth: 375,
            innerHeight: 667,
            scrollX: 0,
            scrollY: 0,
            localStorage: this.createMockStorage(),
            navigator: this.createMockNavigator(),
            document: this.createMockDocument(),
        };
        return (_a = defaults[apiName]) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * 创建模拟的Storage对象
     */
    createMockStorage() {
        const storage = new Map();
        return {
            get length() {
                return storage.size;
            },
            key(index) {
                var _a;
                const keys = Array.from(storage.keys());
                return (_a = keys[index]) !== null && _a !== void 0 ? _a : null;
            },
            clear() {
                storage.clear();
            },
            getItem: (key) => __awaiter(this, void 0, void 0, function* () {
                var _a;
                return (_a = storage.get(key)) !== null && _a !== void 0 ? _a : null;
            }),
            removeItem(key) {
                storage.delete(key);
            },
            setItem(key, value) {
                storage.set(key, value);
            },
        };
    }
    /**
     * 创建模拟的 Navigator 对象
     */
    createMockNavigator() {
        return {
            userAgent: 'WPHK-Platform-Adapter/1.0.0',
            language: 'zh-CN',
            languages: ['zh-CN'],
            onLine: true,
            cookieEnabled: false,
            maxTouchPoints: 5,
            hardwareConcurrency: 4,
            deviceMemory: 4,
            platformType: 'unknown',
            vendor: 'WPHK',
            // 其他必要的属性...
        };
    }
    /**
     * 创建模拟的 Document 对象
     */
    createMockDocument() {
        return {
            documentElement: {},
            body: {},
            head: {},
            title: 'Mock Document',
            referrer: '',
            domain: '',
            URL: '',
            // 其他必要的属性...
        };
    }
    /**
     * 发出错误事件
     */
    emitError(error) {
        if (this.isDebugEnabled) {
            console.warn(`[PlatformAdapter] ${error.message}`, error);
        }
        this.errorCallbacks.forEach((callback) => {
            try {
                callback(error);
            }
            catch (callbackError) {
                console.error('Error callback failed:', callbackError);
            }
        });
    }
}
//# sourceMappingURL=error-handler.js.map